import script from "./SupervisionDataTab.vue?vue&type=script&setup=true&name=SupervisionDataTab&lang=js"
export * from "./SupervisionDataTab.vue?vue&type=script&setup=true&name=SupervisionDataTab&lang=js"

import "./SupervisionDataTab.vue?vue&type=style&index=0&id=913498a8&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-913498a8"]])

export default __exports__